"use strict";
var _a;
exports.__esModule = true;
exports.defaultProcessingFeePercentages = exports.pricingOffer = void 0;
var types_1 = require("../types");
exports.pricingOffer = {
    debit_card_fee_percent: 0.0075,
    debit_card_fee_bips: 75,
    debit_card_fee_amount: 975,
    credit_card_fee_percent: 0.03,
    credit_card_fee_bips: 300,
    credit_card_fee_amount: 3900,
    membership_fee_amount: 1499
};
exports.defaultProcessingFeePercentages = (_a = {},
    _a[types_1.PaymentMethodType.CREDIT] = 3,
    _a[types_1.PaymentMethodType.DEBIT] = 0.75,
    _a);
